export enum LearningPathElementStatus {
  DONE = 'Done',
  CURRENT = 'Current',
  CURRENT_DONE = 'CurrentDone',
  NONE = 'None',
}
